module.exports = __webpack_public_path__ + "img/sm.04729fa8.png";